export function isNumberEven(num: number | string): boolean {
    return Number(num) % 2 === 0;
}

export function isNumberOdd(num: number | string): boolean {
    return Number(num) % 2 !== 0;
}

/**
 * Converts bytes to a human readable size.
 * Code inspired by https://gist.github.com/lanqy/5193417
 */
export function bytesToSize(bytes: number): string {
    const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
    ];

    if (bytes === 0) return 'n/a';

    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), sizes.length - 1);

    if (i === 0) return `${bytes} ${sizes[i]}`;

    return `${(bytes / 1024 ** i).toFixed(0)} ${sizes[i]}`;
}
